import React, { useState, useEffect } from 'react';
import Layout from '../../Global/Layout';
import DataTable from '../../Global/DataTable';
import { ROLE_DISPLAY, getCurrentRole, LOTTO_TYPE, API_CONFIG } from '../../../contexts/constants';
import { LottoBallsDisplay } from '../../../utils/LottoBalls';
import { formatDateTimeTable } from '../../../utils/dateFormatter';
import { formatTHB } from '../../../utils/numberFormat';
import axios from 'axios';

const DashboardPage2 = ({ onLogout, userRole }) => {
	const [activeTab, setActiveTab] = useState('tab1');
	const [loading1, setLoading1] = useState(false);
	const [currentPage1, setCurrentPage1] = useState(1);
	const [pageSize1, setPageSize1] = useState(10);
	const [loading2, setLoading2] = useState(false);
	const [currentPage2, setCurrentPage2] = useState(1);
	const [pageSize2, setPageSize2] = useState(10);
	const [stats, setStats] = useState({
		totalCustomers: 0,
		totalOrders: 0,
		totalAmount: 0
	});
	const [recentOrders, setRecentOrders] = useState([]);
	const [totalOrders, setTotalOrders] = useState(0);
	const [topCustomers, setTopCustomers] = useState([]);
	const [totalCustomers, setTotalCustomers] = useState(0);
	const [otherStats, setOtherStats] = useState([]);
	const currentUserRole = getCurrentRole(userRole);

	// Check user role and redirect if unauthorized
	useEffect(() => {
		if (!['sysadmin', 'agent'].includes(userRole)) {
			window.location.href = '/forbidden';
		}
	}, [userRole]);

	// Fetch dashboard statistics
	useEffect(() => {
		const fetchStats = async () => {
			try {
				const token = localStorage.getItem('token');
				const response = await axios.get(
					`${API_CONFIG.BASE_URL}/dashboard/agent/stats`,
					{
						headers: { Authorization: `Bearer ${token}` }
					}
				);
				if (response.data.success) {
					setStats(response.data.data);
				}
			} catch (error) {
				console.error('Error fetching stats:', error);
			}
		};
		const fetchRecentOrders = async () => {
			setLoading1(true);
			try {
				const token = localStorage.getItem('token');
				const response = await axios.get(
					`${API_CONFIG.BASE_URL}/dashboard/agent/recent-orders`,
					{
						params: {
							page: currentPage1,
							pageSize: pageSize1
						},
						headers: { Authorization: `Bearer ${token}` }
					}
				);
				if (response.data.success) {
					setRecentOrders(response.data.data.orders);
					setTotalOrders(response.data.data.totalItems);
				}
			} catch (error) {
				console.error('Error fetching recent orders:', error);
			} finally {
				setLoading1(false);
			}
		};
		const fetchOtherStats = async () => {
			try {
				const token = localStorage.getItem('token');
				const response = await axios.get(
					`${API_CONFIG.BASE_URL}/dashboard/agent/other-stats`,
					{
						headers: { Authorization: `Bearer ${token}` }
					}
				);
				if (response.data.success) {
					setOtherStats(response.data.data.stats);
				}
			} catch (error) {
				console.error('Error fetching other stats:', error);
			}
		};
		const fetchTopCustomers = async () => {
			setLoading2(true);
			try {
				const token = localStorage.getItem('token');
				const response = await axios.get(
					`${API_CONFIG.BASE_URL}/dashboard/agent/top-customers`,
					{
						params: {
							page: currentPage2,
							pageSize: pageSize2
						},
						headers: { Authorization: `Bearer ${token}` }
					}
				);
				if (response.data.success) {
					setTopCustomers(response.data.data.customers);
					setTotalCustomers(response.data.data.totalItems);
				}
			} catch (error) {
				console.error('Error fetching top customers:', error);
			} finally {
				setLoading2(false);
			}
		};
		fetchRecentOrders();
		fetchStats();
		fetchOtherStats();
		fetchTopCustomers();
	}, [currentPage1, pageSize1, currentPage2, pageSize2, userRole]);

	const columns1 = [
		{
			key: 'create_date',
			className: 'text-center',
			width: '170px',
			header: 'เวลาที่สั่งซื้อ',
			render: (row) => (
				<div className="flex gap-2 justify-center">
					{formatDateTimeTable(row.create_date)}
				</div>
			)
		},
		{ key: 'user_name', header: 'ชื่อลูกค้า' },
		{
			key: 'type',
			header: 'ประเภท',
			render: (row) => (
			<div className="text-center">
				<span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold min-w-36 ${
				row.type === 'powerball'
					? 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300'
					: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300'
				}`}>
				{LOTTO_TYPE[row.type]}
				</span>
			</div>
			)
		},
		{
			key: 'results',
			header: 'ผลรางวัล',
			className: 'text-center',
			render: (row) => (
				<div className="flex gap-2 justify-center">
					<LottoBallsDisplay grayBalls={row.grayBalls} specialBall={row.redBall} type={row.type} />
				</div>
			)
		},
	];
	const columns2 = [
		{
			key: 'no',
			header: 'ลำดับ',
			className: 'text-center',
			width: 100,
			render: (row) => (
				<div className="flex gap-2 justify-center">{row.no}</div>
			)
		},
		{ key: 'user_name', header: 'ชื่อลูกค้า' },
		{
			key: 'user_count',
			header: 'จำนวนเงิน (บาท)',
			className: 'text-center',
			render: (row) => (
				<div className="flex justify-center">
					<span className="font-semibold">
						{row.user_count}
					</span>
				</div>
			)
		},
		{
			key: 'create_date',
			header: 'เวลาที่สั่งซื้อล่าสุด',
			className: 'text-center',
			width: '170px',
			render: (row) => (
				<div className="flex justify-center">
					{formatDateTimeTable(row.create_date)}
				</div>
			)
		},
	];

	const totalPages1 = Math.max(1, Math.ceil(totalOrders / pageSize1));
	const safeCurrentPage1 = Math.min(currentPage1, totalPages1);

	const totalPages2 = Math.max(1, Math.ceil(totalCustomers / pageSize2));
	const safeCurrentPage2 = Math.min(currentPage2, totalPages2);

  	const gotoPage1 = (p) => {
		if (p < 1 || p > totalPages1) return;
		setCurrentPage1(p);
	};

	const gotoPage2 = (p) => {
		if (p < 1 || p > totalPages2) return;
		setCurrentPage2(p);
	};

	return (
		<Layout title={`หน้าแรก ${ROLE_DISPLAY[currentUserRole]}`} onLogout={onLogout} userRole={currentUserRole}>
		<div className="space-y-6">
			<div>
				<p className="text-gray-600 dark:text-gray-400">
					ข้อมูลลูกค้าของท่าน
				</p>
			</div>

			{/* Statistics Cards */}
			<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
				<div className="bg-blue-500 dark:bg-gray-800 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700">
					<p className="text-sm text-white">ลูกค้าทั้งหมด</p>
					<p className="text-2xl font-bold text-white mt-1">{formatTHB(stats.totalCustomers)} <span className='text-sm'>คน</span></p>
				</div>
				<div className="bg-green-500 dark:bg-gray-800 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700">
					<p className="text-sm text-white">จำนวนการสั่งซื้องวดปัจจุบัน</p>
					<p className="text-2xl font-bold text-white mt-1">{formatTHB(stats.totalOrders)} <span className='text-sm'>ใบ</span></p>
				</div>
				<div className="bg-yellow-500 dark:bg-gray-800 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700">
					<p className="text-sm text-white">จำนวนเงินที่ถูกสั่งซื้องวดปัจจุบัน</p>
					<p className="text-2xl font-bold text-white mt-1">{formatTHB(stats.totalAmount)} <span className='text-sm'>บาท</span></p>
				</div>
			</div>

			{/* Tabs Navigation */}
			<div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
			<div className="flex border-b border-gray-200 dark:border-gray-700 grid grid-cols-1 md:grid-cols-3">
				<button
					onClick={() => setActiveTab('tab1')}
					className={`flex-1 px-6 py-4 font-medium transition ${
						activeTab === 'tab1'
						? 'bg-blue-50 dark:bg-[#2a2a2a] text-black dark:text-white/90'
						: 'bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
					}`}
					>
					รายการสั่งซื้อล่าสุด
				</button>
				<button
					onClick={() => setActiveTab('tab2')}
					className={`flex-1 px-6 py-4 font-medium transition ${
						activeTab === 'tab2'
						? 'bg-blue-50 dark:bg-[#2a2a2a] text-black dark:text-white/90'
						: 'bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
					}`}
					>
					ลูกค้าที่มียอดสั่งซื้อสูงสุด
				</button>
				<button
					onClick={() => setActiveTab('tab3')}
					className={`flex-1 px-6 py-4 font-medium transition ${
						activeTab === 'tab3'
						? 'bg-blue-50 dark:bg-[#2a2a2a] text-black dark:text-white/90'
						: 'bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
					}`}
					>
					รายละเอียดอื่นๆ
				</button>
			</div>

			{/* Tab Content */}
			<div className="p-6">
				{activeTab === 'tab1' && (
				<div className="space-y-4">
					<h3 className="text-xl font-bold text-gray-900 dark:text-white">รายการที่ลูกค้าสั่งซื้อ</h3>
					<p className="text-gray-600 dark:text-gray-400">
					รายการที่ลูกค้าได้ทำการสั่งซื้อล่าสุด ในงวดปัจจุบัน
					</p>
					<DataTable
						columns={columns1}
						data={recentOrders}
						loading={loading1}
						page={safeCurrentPage1}
						pageSize={pageSize1}
						totalItems={totalOrders}
						onPageChange={gotoPage1}
						onPageSizeChange={(size) => {
							setPageSize1(size);
							setCurrentPage1(1);
						}}
						emptyMessage="ไม่มีข้อมูลสินค้า"
					/>
				</div>
				)}

				{activeTab === 'tab2' && (
				<div className="space-y-4">
					<h3 className="text-xl font-bold text-gray-900 dark:text-white">จำนวนรายการสั่งซื้อของลูกค้า</h3>
					<p className="text-gray-600 dark:text-gray-400">
						ลูกค้าที่มียอดการสั่งซื้อสูงสุด ในงวดปัจจุบัน
					</p>
					<DataTable
						columns={columns2}
						data={topCustomers}
						loading={loading2}
						page={safeCurrentPage2}
						pageSize={pageSize2}
						totalItems={totalCustomers}
						onPageChange={gotoPage2}
						onPageSizeChange={(size) => {
							setPageSize2(size);
							setCurrentPage2(1);
						}}
						emptyMessage="ไม่มีข้อมูลสินค้า"
					/>
				</div>
				)}

				{activeTab === 'tab3' && (
				<div className="space-y-4">
					<h3 className="text-xl font-bold text-gray-900 dark:text-white">อื่นๆ</h3>
					<p className="text-gray-600 dark:text-gray-400">
						รายละเอียดอื่นๆ ที่น่าสนใจเกี่ยวกับลูกค้าและตัวแทน
					</p>
					{otherStats.length > 0 ? (
						<div className="space-y-3">
							{otherStats.map(item => (
								<div key={item.no} className="flex items-center gap-4 bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
									<div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold">
										{item.no}
									</div>
									<div className="flex-1">
										<h4 className="font-semibold text-gray-900 dark:text-white">{item.title}</h4>
										<p className="text-sm text-gray-600 dark:text-gray-400">{item.detail}</p>
									</div>
								</div>
							))}
						</div>
					) : (
						<p className="text-center text-gray-500 dark:text-gray-400 py-8">
							ไม่มีข้อมูลสถิติในขณะนี้
						</p>
					)}
				</div>
				)}
			</div>
			</div>
		</div>
		</Layout>
	);
};

export default DashboardPage2;
